import { NavLink } from 'react-router';

/** A destination in the primary navigation. */
export interface NavItem {
  readonly to: string;
  readonly label: string;
}

/** Props for {@link AppShell}. */
export interface AppShellProps {
  readonly children: React.ReactNode;
  /** Primary navigation destinations. */
  readonly navItems: readonly NavItem[];
  /**
   * Optional content rendered at the end of the header — the sign-in status and sign-out action in
   * practice. Kept a slot so the shell stays free of auth concerns.
   */
  readonly headerEnd?: React.ReactNode;
}

/**
 * The application chrome: skip link, header, primary navigation and content region.
 *
 * @param props - Component props.
 * @returns The shell element.
 */
export function AppShell({ children, navItems, headerEnd }: AppShellProps): React.JSX.Element {
  return (
    <div className="gm-shell">
      <a className="gm-skip-link" href="#main">
        Skip to content
      </a>

      <header className="gm-header">
        <NavLink to="/" className="gm-brand">
          Grease<span className="gm-brand-mark">map</span>
        </NavLink>

        <nav className="gm-nav" aria-label="Primary">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className="gm-nav-link" end={item.to === '/'}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        {headerEnd}
      </header>

      <main id="main" className="gm-main">
        {children}
      </main>
    </div>
  );
}
